import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { formatRange, dayLabel } from "@/lib/constants";

function mailtoFor(event, tech, days) {
  const lines = [
    `Ciao ${tech.name},`,
    "",
    `ti confermiamo per il servizio "${event.name}".`,
    `Giorni: ${days.map((d) => dayLabel(d, true)).join(", ")}`,
    event.start_time ? `Orario: ${event.start_time}${event.end_time ? ` - ${event.end_time}` : ""}` : null,
    event.location ? `Luogo: ${event.location}` : null,
    event.notes ? `Note: ${event.notes}` : null,
    "",
    "Grazie,",
    "GCAVCOM",
  ].filter((l) => l !== null);
  const subject = `Conferma servizio: ${event.name} (${formatRange(event.start_date, event.end_date || event.start_date)})`;
  return `mailto:${encodeURIComponent(tech.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n"))}`;
}

export function SubcontractorMails({ event, eventRequests, technicians }) {
  const subs = (technicians || []).filter((t) => t.subcontractor)
    .map((t) => ({ t, days: (eventRequests || []).filter((r) => r.technician_id === t.id && r.status === "confermato").map((r) => r.date).sort() }))
    .filter((x) => x.days.length);
  if (!subs.length) return null;
  return (
    <div className="pt-2 border-t border-slate-800 space-y-2" data-testid="subcontractor-mails-section">
      <h4 className="font-semibold flex items-center gap-2"><Mail className="w-4 h-4 text-teal-400" /> Email ai subappaltatori confermati</h4>
      <p className="text-xs text-slate-500">Si apre la tua app di posta con il testo già pronto: puoi modificarlo prima di inviarlo.</p>
      {subs.map(({ t, days }) => (
        <div key={t.id} className="flex items-center gap-2 rounded-lg border border-teal-500/30 bg-teal-500/5 px-3 py-2 text-sm">
          <span className="flex-1 min-w-0"><b>{t.name}</b> <span className="text-slate-400">· {days.map((d) => dayLabel(d)).join(", ")}</span></span>
          <Button asChild size="sm" className="bg-teal-500 hover:bg-teal-600 text-slate-950 font-semibold h-8">
            <a href={mailtoFor(event, t, days)} data-testid={`subcontractor-mail-btn-${t.id}`}><Mail className="w-4 h-4 mr-1.5" />Scrivi email</a>
          </Button>
        </div>
      ))}
    </div>
  );
}
